import Vue from 'vue'
import Vuex from 'vuex'
import io from 'socket.io-client'
import * as uuid from 'uuid'
import * as Api from './api'
import router from './router'
import { fnCopy, fnBuildQuery } from './utils'
import i18n from './i18n'

Vue.use(Vuex)

const models = [
	'Login', 'Forgot', 'Profile', 'Constant', 'Province', 'District', 'Ward', 'RoleAccount', 'Mint',
	'Role', 'Account', 'Banner', 'User', 'Post', 'Report', 'Gift', 'Discovery', 'Topic', 'Order', 'HashTag', 'Push', 'Tracking', 'Setting',
	'DTraffic', 'DUser', 'DPost', 'DDating', 'DQuiz', 'DQuizRanking', 'DQuizByDay', 'DUsers', 'DiscoveryPick'
]

const opt = {
	total: 0,
	list: [],
	obj: {},
	isForm: false,
	isCreate: false,
	isUpdate: false,
	isDelete: false,
	isRefresh: false,
	itemPages: [10, 50, 100, 500, 1000],
	filter: { page: 1, limit: 10, sort: 'createdAt:-1' }
}

const phoneRex = /^((09[0|1|2|3|4|6|7|8|9]|08[1|2|3|4|5|6|8|9]|07[0|6|7|8|9]|05[2|6|8|9]|03[2|3|4|5|6|7|8|9])+([0-9]{7})|(0101+([0-9]{6})))$\b/

const rules = {
	required: v => !!v || i18n.messages[i18n.locale].rule.required,
	number: v => Number(v) >= 0 || i18n.messages[i18n.locale].rule.number,
	phone: v => v ? phoneRex.test(v) || i18n.messages[i18n.locale].rule.phone : true,
	minPass: v => (!!v && v.length >= 5) || 'Must be minimum 5 characters',
	array: v => (v && !!v.length) || i18n.messages[i18n.locale].rule.required,
	email: v => v ? /.+@.+/.test(v) || i18n.messages[i18n.locale].rule.email : true,
	date: v => /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i.test(v) || i18n.messages[i18n.locale].rule.date,
	dateTime: v => /^([0-1][0-9]|(2)[0-3]):([0-5][0-9])\s([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i.test(v) || i18n.messages[i18n.locale].rule.date,
}

const mission = {
	ROLE: '5ed347a9e6278057e83ad6e8',
	ACCOUNT: '5ed347a9e6278057e83ad6d4',
	USER: '5fea9cb8dc43203f07d4e637',
	BANNER: '5fea9cb8dc43203f07d4e636',
	POST: '5fea9cb8dc43203f07d4e638',
	GIFT: '5feacf82dc43203f07d4e639',
	TOPIC: '608674998131ed7cc219c6c5',
	ORDER: '5ff40d9189e3051a47e7cfea',
	HASHTAG: '60af185ded4ed1f5d09b5837',
	PUSH: '60e2bcffbc9a19d907f1a6a8',
	TRACKING: '610c8c71601dcdab0c625285',
	DASHBOARD: '612e02dcafb95d03f43131e1',
	SETTING: '61df910e2551505c3fa2ec55',
	DISCOVERY: '6209d40997e3e72f6022494a',
	MINT: '62b42fdf6c7251ee1e094f33',
}

const privilege = {
	READ: '5ed34726e6278057e83ad496',
	CREATE: '5ed34726e6278057e83ad4a8',
	UPDATE: '5ed34726e6278057e83ad4b2',
	DELETE: '5ed34726e6278057e83ad4bc',
	ADMIN: '5ef1fafa80b9110bae0d28fe',
	APPROVE: '5f786322f141990849faa338',
	ASSIGN: '5ef1fbcc80b9110bae0d2900',
	EXECUTE: '5f1d4285ff82470e7d1d0235',
	IMPORT: '5f00e70250d2b30730da0906',
	EXPORT: '5facb6686cf962dc844f9198',
}

export const state = {
	Api,
	Host: process.env.VUE_APP_API,
	Socket: undefined,
	Token: {},
	Session: {},
	Notifications: [],
	IsLogin: false,
	Rules: { ...rules },
	...models.reduce((o, k) => ({ ...o, [k]: fnCopy(opt) }), {}),
	...mission,
	...privilege
}

export const actions = {
	fnSocket: ({ state }) => {
		if (state.Socket) state.Socket.disconnect()
		state.Socket = io.connect(process.env.VUE_APP_API, { transports: ['websocket'], query: { token: state.Token.access_token } })
		state.Socket.on('connect', () => console.log('connected'))
		state.Socket.on('disconnect', () => console.log('disconnect'))
		state.Socket.on('error', error => console.log(error))
	},
	fnGetToken: ({ state }) => {
		if (!state.IsLogin && localStorage.getItem('token')) {
			try { state.Token = JSON.parse(localStorage.getItem('token')) }
			catch (_) { }
		}
		return state.Token
	},
	fnSetToken: async ({ state, dispatch }, data) => {
		state.Token = data
		localStorage.setItem('token', JSON.stringify(data))
		await dispatch('fnGetMe')
		await dispatch('fnSocket')
	},
	fnGetMe: async ({ state, dispatch }) => {
		await dispatch('fnGetToken')
		if (!state.Token.access_token) return
		if (Object.keys(state.Session).length) return state.Session
		const { code, data } = await Api.get({ url: '/v1/admin/me' })
		if (code === 200) {
			state.IsLogin = true
			state.Session = data
			await dispatch('fnGets', { url: '/v1/admin/constant', model: 'Constant' })
		}
	},
	fnLogout: async ({ state }) => {
		await Api.del({ url: `/v1/admin/me/${state.Session.id}?token=${state.Token.access_token}` })
		state.Token = {}
		state.Session = {}
		state.IsLogin = false
		localStorage.clear()
		router.push('/login')
	},
	fnGets: async ({ state }, { url, model }) => {
		const { code, data, total } = await Api.get({ url: `${url}?${fnBuildQuery(state[model].filter)}` })
		if (code === 200) {
			if (Array.isArray(data)) {
				state[model].list = data
				state[model].total = total
			} else state[model].obj = data
		}
		return { code, data, total }
	},
	fnGet: async ({ state }, { url, model }) => {
		const { code, data, message } = await Api.get({ url })
		if (code === 200) state[model].obj = data
		return { code, data, message }
	},
	fnPost: async ({ state, dispatch }, { url, model }) => {
		const { code, data, message } = await Api.post({ url, body: state[model].obj })
		dispatch('fnNotificationView', { type: code === 200 ? 'success' : 'error', message })
		return { code, data }
	},
	fnPut: async ({ state, dispatch }, { url, model }) => {
		const { code, data, message } = await Api.put({ url, body: state[model].obj })
		dispatch('fnNotificationView', { type: code === 200 ? 'success' : 'error', message })
		return { code, data }
	},
	fnDelete: async ({ dispatch }, { url }) => {
		const { code, data, message } = await Api.del({ url })
		dispatch('fnNotificationView', { type: code === 200 ? 'success' : 'error', message })
		return { code, data }
	},
	fnResetFlagView: ({ state }, model) => {
		state[model] = { ...state[model], obj: {}, isForm: false, isValid: false, isCreate: false, isUpdate: false, isDelete: false, isRefresh: false }
	},
	fnCallListView: ({ dispatch }, { url, model }) => {
		dispatch('fnResetFlagView', model)
		dispatch('fnGets', { url, model })
	},
	fnCallCreateView: ({ dispatch, state }, model) => {
		dispatch('fnResetFlagView', model)
		state[model].isForm = true
		state[model].isCreate = true
	},
	fnCallUpdateView: ({ dispatch, state }, { model, item }) => {
		dispatch('fnResetFlagView', model)
		state[model].isForm = true
		state[model].isUpdate = true
		state[model].obj = fnCopy(item)
	},
	fnCallDeleteView: ({ dispatch, state }, { model, item }) => {
		dispatch('fnResetFlagView', model)
		state[model].isDelete = true
		state[model].obj = fnCopy(item)
	},
	fnNotificationView: ({ state }, { type, message }) => {
		const noti = { type, message, key: uuid.v4() }
		state.Notifications.push(noti)
		setTimeout(() => { state.Notifications = state.Notifications.filter(e => e.key != noti.key) }, 3000)
	}
}

export default new Vuex.Store({ actions, state })
